import React from 'react';
import Auth from '../services/auth';
const auth = new Auth();

const Signin = () => {
  auth.login();
  return <div />;
};

export default Signin;



// WEBPACK FOOTER //
// ./src/pages/Signin.js